import { render, staticRenderFns } from "./characteristics.index.component.vue?vue&type=template&id=4df11824&scoped=true&"
import script from "./characteristics.index.component.vue?vue&type=script&lang=js&"
export * from "./characteristics.index.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df11824",
  null
  
)

export default component.exports